
import React, { useState, useEffect } from "react";
import { cn } from "@/lib/utils";
import { useLocation } from "react-router-dom";

interface NavItem {
  name: string;
  url: string;
}

interface NavBarProps {
  items: NavItem[];
  className?: string;
  activeIndex?: number;
}

export function NavBar({ items, className, activeIndex }: NavBarProps) {
  const location = useLocation();
  const [activeItem, setActiveItem] = useState<number>(0);

  // Set active item based on current URL path or passed activeIndex
  useEffect(() => {
    if (activeIndex !== undefined) {
      setActiveItem(activeIndex);
      return;
    }

    const currentPath = location.pathname;
    const currentHash = location.hash;
    
    const index = items.findIndex(item => {
      // For the root path
      if (item.url === '/' && currentPath === '/' && !currentHash) {
        return true;
      }
      // For regular routes like /work
      if (item.url !== '/' && !item.url.includes('#') && item.url === currentPath) {
        return true;
      }
      // For hash routes like /#about
      if (item.url.includes('#') && currentPath === '/' && item.url.endsWith(currentHash)) {
        return true;
      }
      return false;
    });
    
    if (index !== -1) {
      setActiveItem(index);
    }
  }, [location, items, activeIndex]);

  return (
    <div className={cn("relative flex justify-center", className)}>
      <div className="flex h-14 items-center justify-center rounded-full glass-effect px-6 shadow-soft">
        {items.map((item, idx) => (
          <a
            key={idx}
            href={item.url}
            className={cn(
              "relative flex h-10 items-center justify-center px-4 text-sm transition-all duration-300",
              activeItem === idx 
                ? "text-cyan-400 font-medium shadow-glow" 
                : "text-offWhite/80 hover:text-cyan-400"
            )}
            onClick={(e) => {
              setActiveItem(idx);
            }}
          >
            <span>{item.name}</span>
          </a>
        ))}
      </div>
    </div>
  );
}
